/**
 * TestSubmission component is responsible for displaying the evaluation results
 * of a student's submission. It includes running the test cases, displaying
 * test results, and showing a loading spinner during the process.
 */
import log from "loglevel";
import React, { useEffect, useState } from "react";
import { Accordion, Card } from "react-bootstrap";
import RunTestcases from "../RuntestCases/RuntestCases.jsx";
import TestcaseResults from "../TestCaseResults/TestcaseResults.jsx";
import LoadingSpinner from "../Loading Spinner/LoadingSpinner.jsx";
import "../Loading Spinner/spinner.css";
import httpService from 'services/httpService.js';
import { RiArrowDropDownLine, RiArrowDropRightLine } from "react-icons/ri";

export default function TestSubmission({
  programId,
  selectedSubmission,
  access,
  changeAccess,
  setTestResults,
  testResults,
  delegate_student_id,
  practiceMarks,
  evaluateMarks,
  visibleTestcaseEvaluationResultsStatus,
  setVisibleTestcaseEvaluationResultsStatus,
  hiddenTestcaseEvaluationResultStatus,
  setHiddenTestcaseEvaluationResultStatus
}) {
  const [isLoading, setIsLoading] = useState(false); //state for loading spinner
  const [isSubmissionChanged, setIsSubmissionChanged] = useState(false); //state for checking if submission is changed or not
  const [isAccordionOpen, setIsAccordionOpen] = useState(true);

  useEffect(() => {
    setIsSubmissionChanged(true);
  }, [selectedSubmission]);

  const testcasesExportHandler = async (url, testcaseName) => {
    //testcases export handler
    const FileDownload = require("js-file-download");
    try {
      const response = await httpService.instance({
        url,
        method: "GET",
        responseType: "blob", // Important
      });
      FileDownload(response.data, testcaseName);
    } catch (error) {
      log.log(error);
    }
  };
  return (
    <Accordion defaultActiveKey="0">
      <Card>
        <Accordion.Toggle
          as={Card.Header}
          onClick={() => setIsAccordionOpen(!isAccordionOpen)}
        >
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div>Testcase results</div>
            <div>
              {isAccordionOpen ? (
                <RiArrowDropDownLine
                  size={35}
                  color="grey"
                  style={{ margin: "-10 0 -10 10" }}
                />
              ) : (
                <RiArrowDropRightLine
                  size={35}
                  color="grey"
                  style={{ margin: "-10 0 -10 10" }}
                />
              )}
            </div>
          </div>
        </Accordion.Toggle>
        <Accordion.Collapse in={isAccordionOpen}>
          <Card.Body>
            <div>
              <RunTestcases
                programId={programId}
                selectedSubmission={selectedSubmission}
                isLoading={isLoading}
                setIsLoading={setIsLoading}
                access={access}
                changeAccess={changeAccess}
                setTestResults={setTestResults}
                testcasesExportHandler={testcasesExportHandler}
                setIsSubmissionChanged={setIsSubmissionChanged}
                delegate_student_id={delegate_student_id}
                practiceMarks={practiceMarks}
                evaluateMarks={evaluateMarks}
                visibleTestcaseEvaluationResultsStatus={visibleTestcaseEvaluationResultsStatus}
                setVisibleTestcaseEvaluationResultsStatus={setVisibleTestcaseEvaluationResultsStatus}
                hiddenTestcaseEvaluationResultStatus={hiddenTestcaseEvaluationResultStatus}
                setHiddenTestcaseEvaluationResultStatus={setHiddenTestcaseEvaluationResultStatus}
              />
              {isLoading ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <LoadingSpinner />
                </div>
              ) : !isSubmissionChanged ? (
                <div style={{ overflow: "auto" }}>
                  <TestcaseResults
                    programId={programId}
                    access={access}
                    testResults={testResults}
                    testcasesExportHandler={testcasesExportHandler}
                  />
                </div>
              ) : null}
            </div>
          </Card.Body>
        </Accordion.Collapse>
      </Card>
    </Accordion>
  );
}


TestSubmission.defaultProps = {
  programId: "",
  selectedSubmission: "",
  access: {},
  changeAccess: () => {},
  setTestResults: () => {},
  testResults: [],
  delegate_student_id: null,
};
